import type { TableHeaderSpec } from '@/@vxapp/@Types/ServiceMetadata'

export const QuotesTableHeaders = [
  {
    title: '#ID',
    align: 'start',
    key: 'id',
    placeholder: '00000',
  },
  {
    title: 'Status',
    align: 'start',
    key: 'quoteStatus',
    sortable: true,
    placeholder: null,
  },
  {
    skeletonOnly: true,
    title: 'Status',
    align: 'start',
    key: 'status',
    sortable: true,
    placeholder: 6,
  },
  {
    title: 'Contact',
    align: 'start',
    key: 'contactData',
    sortable: false,
    placeholder: '######## ##########',
  },
  {
    title: 'Job Type',
    align: 'start',
    key: 'JOB_TYPE_NAME',
    sortable: false,
    placeholder: 'Job Type Name',
  },
  {
    title: 'Job Details',
    align: 'start',
    key: 'job',
    sortable: false,
    placeholder: 'Job Description',
  },
  /*{
    title: 'Total',
    align: 'start',
    key: 'total',
    sortable: false,
    placeholder: '0.00',
  },*/
  {
    title: 'Date',
    align: 'start',
    key: 'SERVICE_DATE',
    sortable: false,
    placeholder: '00/00/0000',
  },
  {
    title: 'Actions',
    align: 'end',
    key: 'actions',
    sortable: false,
  },
] as const satisfies readonly TableHeaderSpec[]
